exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".previewClipartContainer{position:absolute;background:transparent;background-size:contain;background-position:50%;background-repeat:no-repeat}.editArea{transform-origin:left top;white-space:nowrap;overflow:visible}.north{width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22f28bdc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Preview/PreviewClipart.vue
// module id = 79
// module chunks = 0